// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file user_confirmation_type.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file user_confirmation_type.proto.
 */
export const file_user_confirmation_type: GenFile = /*@__PURE__*/
  fileDesc("Chx1c2VyX2NvbmZpcm1hdGlvbl90eXBlLnByb3RvEgZkb21haW4qyAUKFFVzZXJDb25maXJtYXRpb25UeXBlEiIKHlVTRVJfQ09ORklSTUFUSU9OX1RZUEVfVU5LTk9XThAAEiAKHFVTRVJfQ09ORklSTUFUSU9OX1RZUEVfREVCVUcQARItCihVU0VSX0NPTkZJUk1BVElPTl9UWVBFX1VTRVJfRVhQT1JUX1ZBVUxUEJFOEisKJlVTRVJfQ09ORklSTUFUSU9OX1RZUEVfVVNFUl9FWFBPUlRfQUxMEJJOEjUKMFVTRVJfQ09ORklSTUFUSU9OX1RZUEVfVVNFUl9FWFBPUlRfT1JHX0FMTF9URUFNUxCTThI4CjNVU0VSX0NPTkZJUk1BVElPTl9UWVBFX1VTRVJfRVhQT1JUX09SR19NRU1CRVJfVEVBTVMQlE4SMQosVVNFUl9DT05GSVJNQVRJT05fVFlQRV9VU0VSX1NIT1dfQkFDS1VQX0NPREUQmk4SNwoyVVNFUl9DT05GSVJNQVRJT05fVFlQRV9VU0VSX1JFR0VORVJBVEVfQkFDS1VQX0NPREUQm04SPAo3VVNFUl9DT05GSVJNQVRJT05fVFlQRV9VU0VSX0FERF9DUkVERU5USUFMX1NFQ1VSSVRZX0tFWRCkThI9CjhVU0VSX0NPTkZJUk1BVElPTl9UWVBFX1VTRVJfQUREX0NSRURFTlRJQUxfV0lORE9XU19IRUxMTxClThI4CjNVU0VSX0NPTkZJUk1BVElPTl9UWVBFX1VTRVJfQUREX0NSRURFTlRJQUxfVE9VQ0hfSUQQpk4SMQorVVNFUl9DT05GSVJNQVRJT05fVFlQRV9PUkdfQURNSU5fREVMRVRFX09SRxCw6gESRwpBVVNFUl9DT05GSVJNQVRJT05fVFlQRV9PUkdfQURNSU5fQ09OVkVSVF9DSElMRF9PUkdfVE9fSU5ERVBFTkRFTlQQsuoBQlIKGmFwcC5oZXlsb2dpbi5hbmRyb2lkLnByb3RvWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiogIDSFBBYgZwcm90bzM");

/**
 * @generated from enum domain.UserConfirmationType
 */
export enum UserConfirmationType {
  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_DEBUG = 1;
   */
  DEBUG = 1,

  /**
   * 10000 Prefix - General
   *
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_EXPORT_VAULT = 10001;
   */
  USER_EXPORT_VAULT = 10001,

  /**
   * Deprecated
   *
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_EXPORT_ALL = 10002;
   */
  USER_EXPORT_ALL = 10002,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_EXPORT_ORG_ALL_TEAMS = 10003;
   */
  USER_EXPORT_ORG_ALL_TEAMS = 10003,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_EXPORT_ORG_MEMBER_TEAMS = 10004;
   */
  USER_EXPORT_ORG_MEMBER_TEAMS = 10004,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_SHOW_BACKUP_CODE = 10010;
   */
  USER_SHOW_BACKUP_CODE = 10010,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_REGENERATE_BACKUP_CODE = 10011;
   */
  USER_REGENERATE_BACKUP_CODE = 10011,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_ADD_CREDENTIAL_SECURITY_KEY = 10020;
   */
  USER_ADD_CREDENTIAL_SECURITY_KEY = 10020,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_ADD_CREDENTIAL_WINDOWS_HELLO = 10021;
   */
  USER_ADD_CREDENTIAL_WINDOWS_HELLO = 10021,

  /**
   * @generated from enum value: USER_CONFIRMATION_TYPE_USER_ADD_CREDENTIAL_TOUCH_ID = 10022;
   */
  USER_ADD_CREDENTIAL_TOUCH_ID = 10022,

  /**
   * 30000 Prefix - Organization Admin
   *
   * @generated from enum value: USER_CONFIRMATION_TYPE_ORG_ADMIN_DELETE_ORG = 30000;
   */
  ORG_ADMIN_DELETE_ORG = 30000,

  /**
   * USER_CONFIRMATION_TYPE_ORG_ADMIN_DEMOTE_SELF = 30001;
   *
   * @generated from enum value: USER_CONFIRMATION_TYPE_ORG_ADMIN_CONVERT_CHILD_ORG_TO_INDEPENDENT = 30002;
   */
  ORG_ADMIN_CONVERT_CHILD_ORG_TO_INDEPENDENT = 30002,
}

/**
 * Describes the enum domain.UserConfirmationType.
 */
export const UserConfirmationTypeSchema: GenEnum<UserConfirmationType> = /*@__PURE__*/
  enumDesc(file_user_confirmation_type, 0);

